// Models
import { Injectable, Inject } from '@angular/core';

// Libraries
import { HttpClient } from '@angular/common/http';

// Services
import { CoreService } from '../../../../shared/services';

// Models
import { AppCleanup } from '../../../../shared/models';
import { UnitViewModel } from '../models/unit-view.model';
import { UnitDetailViewModel } from '../models/unit-detail-view.model';
import { UnitUserAddDto } from '../models/unit-user-add-dto.model';
import { UnitUserViewModel } from '../models/unit-user-view.model';
import { UserModel } from '../../../../shared/models';
import { AssetViewModel } from '../../string/models/string-view.model';
import { DeviceUnitViewModel } from '../../../unit-config/services/device.service';

@Injectable({
	providedIn: 'root',
})
export class UnitService extends AppCleanup {
	private readonly unitUrl: string;

	constructor(
		private http: HttpClient,
		private coreService: CoreService
	) {
		super();
		this.unitUrl = `${this.apiUrl}api/unit`;
	}

	getUnits() {
		return this.http.get<UnitViewModel[]>(this.unitUrl);
	}

	getUnit(id: number) {
		return this.http.get<UnitDetailViewModel>(`${this.unitUrl}/${id}`);
	}

	createUnit(unit: CustomUnitModel) {
		return this.http.post<DeviceUnitViewModel | UnitDetailViewModel>(`${this.unitUrl}`, unit);
	}

	deleteTemporaryUnit(id: number) {
		return this.http.delete<CustomUnitModel[]>(`${this.unitUrl}/temporary/${id}`);
	}

	updateUnit(unit: UnitViewModel) {
		return this.http.put<UnitViewModel>(`${this.unitUrl}`, unit);
	}

	addUsersToUnit(model: UnitUserAddDto) {
		return this.http.post<UnitUserViewModel[]>(`${this.unitUrl}/user`, model);
	}

	deleteUserFromUnit(unitUserId: number) {
		return this.http.delete<UserModel>(`${this.unitUrl}/user/${unitUserId}`);
	}

	refreshUnits() {
		return this.http.post<UnitViewModel[]>(`${this.unitUrl}/refresh`, {});
	}

	getUnitBops(unitGuid: string) {
		return this.http.get<AssetViewModel[]>(`${this.unitUrl}/${unitGuid}/bop`);
	}
}

export class CustomUnitModel {
	deviceId: number;
	unitName: string;
	unitDescription: string;
	unitTypeId: number;
	isTemporaryUnit: boolean;
}

export class MatchTemporaryUnitModel {
	temporaryUnitId: number;
	existingUnitId: number;
}
